export default __webpack_public_path__ + "static/media/star.8edd1113.svg";